import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 9,
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14 12L11 13.7321L11 10.2679L14 12Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})]
});
export default SvgPlayCircle;
